import { showSuccess, showError } from '@/utils/toastHelpers';
import { useCreateOrganizer, useUpdateOrganizer, useDeleteOrganizer } from '@/hooks/useOrganizers';
import { useEntityActions } from '@/hooks/useEntityActions';
import { Organizer, OrganizerFormData } from './organizersmanager.props';

const emptyForm: OrganizerFormData = { name: '', description: '', logo: '', website: '', email: '', password: '' };

export const useOrganizersActions = () => {
  const createOrganizer = useCreateOrganizer();
  const updateOrganizer = useUpdateOrganizer();
  const deleteOrganizer = useDeleteOrganizer();

  const crud = useEntityActions<Organizer, OrganizerFormData>({
    emptyForm,
    deleteMutation: deleteOrganizer,
    entityName: 'Организаторот',
  });

  const handleEdit = (organizer: Organizer) => {
    crud.openEdit(organizer, (o) => ({
      name: o.name, description: o.description, logo: o.logo,
      website: o.website, email: o.email || '', password: '',
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      if (crud.editingEntity) {
        await updateOrganizer.mutateAsync({ id: crud.editingEntity.id, data: crud.formData });
        showSuccess('Успешно ажурирано', 'Организаторот е успешно ажуриран.');
      } else {
        await createOrganizer.mutateAsync(crud.formData);
        showSuccess('Успешно креирано', 'Нов организатор е успешно креиран.');
      }
      crud.resetDialog();
    } catch (error) {
      showError(error, 'организаторот');
    }
  };

  return {
    isDialogOpen: crud.isDialogOpen, setIsDialogOpen: crud.setIsDialogOpen,
    editingOrganizer: crud.editingEntity, setEditingOrganizer: crud.setEditingEntity,
    deleteTarget: crud.deleteTarget, setDeleteTarget: crud.setDeleteTarget,
    formData: crud.formData, setFormData: crud.setFormData,
    handleEdit, handleDelete: crud.handleDelete, confirmDelete: crud.confirmDelete, handleSubmit,
  };
};
